export const PentairProperties = {
  'Pentair_NAEndSuctionComm': {}
};
